import React from 'react'

// Styles
import styles from './Footer.module.scss'
import { ReactComponent as ApplePay } from '../../assets/apple-pay-white.svg'
import { ReactComponent as TokNSmall } from '../../assets/tok-n-logo-s.svg'
import { ReactComponent as TokNLogo } from '../../assets/tok-n-logotype.svg'


export default function Footer () {

  return (
    <div className={styles.footer}>
      <div className={styles.footerDescription}>Pay here using</div>
      <div className={styles.footerIcon}><ApplePay/></div>
      <div className={styles.footerIcon}><img src="google-pay.png" /></div>
      <div className={styles.TokNIcon}><TokNSmall/></div>
    </div>
  )
}
